<template>
    <div v-observe-visibility="visibilityChanged">

        <v-dialog class="loading-dialog"
                  v-model="loading"
                  persistent
                  overlay
                  max-width="300px">
            <v-card>
                <v-layout row pt-4 pb-4 pr-4 pl-4>
                    <v-flex xs12>
                        <v-card-title class="headline">Loading...</v-card-title>
                    </v-flex>
                    <v-flex justify-end>
                        <v-progress-circular
                                :size="70"
                                :width="7"
                                color="primary"
                                indeterminate
                        ></v-progress-circular>
                    </v-flex>
                </v-layout>
            </v-card>
        </v-dialog>

        <v-container mt-2 v-if="$vuetify.breakpoint.smAndUp">

            <v-card>

                <v-card-title>
                    <div>
                        <h3>Send Order Confirmation</h3>
                    </div>
                </v-card-title>
                <v-layout row wrap>
                    <v-container ml-2 mr-2>
                        <v-flex xs12>
                            <v-autocomplete class="line-height"
                                            label="Send To:"
                                            multiple
                                            chips
                                            v-model="selectedSendToItems"
                                            persistent-hint
                                            :deletable-chips=chipsDeletable
                                            :items="getCustomerBranchOfficeContacts"
                                            :filter="customContactFilter"
                                            item-value="id"
                                            item-text="name"

                            >

                                <template slot="selection" slot-scope="data">
                                    <v-chip v-if="data.item.main_contact"
                                            color="primary"
                                            :selected="data.selected"
                                            close
                                            class="chip--select-multi white--text"
                                            @input="removeSendToItem(data.item)"
                                    >
                                        {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                        data.item.lastname }}
                                    </v-chip>
                                    <v-chip v-else
                                            :selected="data.selected"
                                            close
                                            class="chip--select-multi"
                                            @input="removeSendToItem(data.item)"
                                    >
                                        {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                        data.item.lastname }}
                                    </v-chip>
                                </template>

                                <template slot="item" slot-scope="data">
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                            data.item.lastname }}
                                        </v-list-tile-title>

                                        <v-list-tile-sub-title v-if="data.item.main_contact"
                                        >Main Contact
                                        </v-list-tile-sub-title>

                                    </v-list-tile-content>
                                </template>

                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 mt-4>
                            <v-autocomplete class="line-height"
                                            label="CC:"
                                            v-model="selectedCCItems"
                                            multiple
                                            chips
                                            persistent-hint
                                            :deletable-chips=chipsDeletable
                                            :items="getCustomerBranchOfficeContacts"
                                            :filter="customContactFilter"
                                            item-value="id"
                                            item-text="name"

                            >

                                <template slot="selection" slot-scope="data">
                                    <v-chip v-if="data.item.main_contact"
                                            color="primary"
                                            :selected="data.selected"
                                            close
                                            class="chip--select-multi white--text"
                                            @input="removeCCItem(data.item)"
                                    >
                                        {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                        data.item.lastname }}
                                    </v-chip>
                                    <v-chip v-else
                                            :selected="data.selected"
                                            close
                                            class="chip--select-multi"
                                            @input="removeCCItem(data.item)"
                                    >
                                        {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                        data.item.lastname }}
                                    </v-chip>
                                </template>

                                <template slot="item" slot-scope="data">
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                            data.item.lastname }}
                                        </v-list-tile-title>

                                        <v-list-tile-sub-title v-if="data.item.main_contact"
                                        >Main Contact
                                        </v-list-tile-sub-title>

                                    </v-list-tile-content>
                                </template>

                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 mt-4>
                            <v-autocomplete class="line-height"
                                            label="BCC:"
                                            v-model="selectedBCCItems"
                                            multiple
                                            chips
                                            persistent-hint
                                            :deletable-chips=chipsDeletable
                                            :items="getCustomerBranchOfficeContacts"
                                            :filter="customContactFilter"
                                            item-value="id"
                                            item-text="name"
                            >
                                <template slot="selection" slot-scope="data">
                                    <v-chip v-if="data.item.main_contact"
                                            color="primary"
                                            :selected="data.selected"
                                            close
                                            class="chip--select-multi white--text"
                                            @input="removeBCCItem(data.item)"
                                    >
                                        {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                        data.item.lastname }}
                                    </v-chip>
                                    <v-chip v-else
                                            :selected="data.selected"
                                            close
                                            class="chip--select-multi"
                                            @input="removeBCCItem(data.item)"
                                    >
                                        {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                        data.item.lastname }}
                                    </v-chip>
                                </template>

                                <template slot="item" slot-scope="data">
                                    <v-list-tile-content>
                                        <v-list-tile-title>
                                            {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                            data.item.lastname }}
                                        </v-list-tile-title>

                                        <v-list-tile-sub-title v-if="data.item.main_contact"
                                        >Main Contact
                                        </v-list-tile-sub-title>

                                    </v-list-tile-content>
                                </template>

                            </v-autocomplete>
                        </v-flex>
                        <v-flex xs12 mt-4>
                            <v-text-field class="line-height"
                                          label="Subject:"
                                          counter
                                          maxlength="255"
                                          v-model="getSubject"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 mb-5 mt-5>
                            <htmlEditor v-model="myHTML"></htmlEditor>
                        </v-flex>
                        <v-flex xs12 mb-1>
                            <v-layout justify-end>
                                <v-layout row>
                                  <DocumentTokenChip
                                    v-show="getOrderConfirmationDocumentId!== 0"
                                    :documentsId="getOrderConfirmationDocumentId"
                                    :documentFilename="getAttachmentFilenameOC"
                                  >
                                  </DocumentTokenChip>

                                  <DocumentTokenChip
                                    v-show="getProformaDocumentId!== 0 && selectedItem.proforma"
                                    :documentsId="getProformaDocumentId"
                                    :documentFilename="getAttachmentFilenamePRO"
                                  >
                                  </DocumentTokenChip>
                                </v-layout>
                                <v-btn :disabled="selectedSendToItems.length <= 0" mt-5 color="secondary" @click="sendSupplierRequest()">
                                    Send Order Confirmation
                                    <v-icon class="white--text" right>send</v-icon>
                                </v-btn>
                            </v-layout>
                        </v-flex>
                        <v-flex xs12 mb-5>
                            <v-layout justify-end>
                                <v-btn mt-5 dark color="secondary" @click="createProcurement()">
                                    Create Procurement
                                    <v-icon class="icon-padding" v-html="'fa fa-shopping-cart'"></v-icon>
                                </v-btn>
                            </v-layout>
                        </v-flex>
                    </v-container>
                </v-layout>

            </v-card>

        </v-container>

        <div mt-2 v-else>

            <v-card-title>
                <div>
                    <h3>Send Order Confirmation</h3>
                </div>
            </v-card-title>

            <v-layout row wrap>
                <v-container>
                    <v-flex xs12>
                        <v-autocomplete class="line-height"
                                        label="Send To:"
                                        multiple
                                        chips
                                        v-model="selectedSendToItems"
                                        persistent-hint
                                        :deletable-chips=chipsDeletable
                                        :items="getCustomerBranchOfficeContacts"
                                        :filter="customContactFilter"
                                        item-value="id"
                                        item-text="name"

                        >

                            <template slot="selection" slot-scope="data">
                                <v-chip v-if="data.item.main_contact"
                                        color="primary"
                                        :selected="data.selected"
                                        close
                                        class="chip--select-multi white--text"
                                        @input="removeSendToItem(data.item)"
                                >
                                    {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                    data.item.lastname }}
                                </v-chip>
                                <v-chip v-else
                                        :selected="data.selected"
                                        close
                                        class="chip--select-multi"
                                        @input="removeSendToItem(data.item)"
                                >
                                    {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                    data.item.lastname }}
                                </v-chip>
                            </template>

                            <template slot="item" slot-scope="data">
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                        data.item.lastname }}
                                    </v-list-tile-title>

                                    <v-list-tile-sub-title v-if="data.item.main_contact"
                                    >Main Contact
                                    </v-list-tile-sub-title>

                                </v-list-tile-content>
                            </template>

                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 mt-4>
                        <v-autocomplete class="line-height"
                                        label="CC:"
                                        v-model="selectedCCItems"
                                        multiple
                                        chips
                                        persistent-hint
                                        :deletable-chips=chipsDeletable
                                        :items="getCustomerBranchOfficeContacts"
                                        :filter="customContactFilter"
                                        item-value="id"
                                        item-text="name"

                        >

                            <template slot="selection" slot-scope="data">
                                <v-chip v-if="data.item.main_contact"
                                        color="primary"
                                        :selected="data.selected"
                                        close
                                        class="chip--select-multi white--text"
                                        @input="removeCCItem(data.item)"
                                >
                                    {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                    data.item.lastname }}
                                </v-chip>
                                <v-chip v-else
                                        :selected="data.selected"
                                        close
                                        class="chip--select-multi"
                                        @input="removeCCItem(data.item)"
                                >
                                    {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                    data.item.lastname }}
                                </v-chip>
                            </template>

                            <template slot="item" slot-scope="data">
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                        data.item.lastname }}
                                    </v-list-tile-title>

                                    <v-list-tile-sub-title v-if="data.item.main_contact"
                                    >Main Contact
                                    </v-list-tile-sub-title>

                                </v-list-tile-content>
                            </template>

                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 mt-4>
                        <v-autocomplete class="line-height"
                                        label="BCC:"
                                        v-model="selectedBCCItems"
                                        multiple
                                        chips
                                        persistent-hint
                                        :deletable-chips=chipsDeletable
                                        :items="getCustomerBranchOfficeContacts"
                                        :filter="customContactFilter"
                                        item-value="id"
                                        item-text="name"
                        >
                            <template slot="selection" slot-scope="data">
                                <v-chip v-if="data.item.main_contact"
                                        color="primary"
                                        :selected="data.selected"
                                        close
                                        class="chip--select-multi white--text"
                                        @input="removeBCCItem(data.item)"
                                >
                                    {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                    data.item.lastname }}
                                </v-chip>
                                <v-chip v-else
                                        :selected="data.selected"
                                        close
                                        class="chip--select-multi"
                                        @input="removeBCCItem(data.item)"
                                >
                                    {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                    data.item.lastname }}
                                </v-chip>
                            </template>

                            <template slot="item" slot-scope="data">
                                <v-list-tile-content>
                                    <v-list-tile-title>
                                        {{ data.item.title ? data.item.title : '' }} {{ data.item.firstname }} {{
                                        data.item.lastname }}
                                    </v-list-tile-title>

                                    <v-list-tile-sub-title v-if="data.item.main_contact"
                                    >Main Contact
                                    </v-list-tile-sub-title>

                                </v-list-tile-content>
                            </template>

                        </v-autocomplete>
                    </v-flex>
                    <v-flex xs12 mt-4>
                        <v-text-field class="line-height"
                                      label="Subject:"
                                      counter
                                      maxlength="255"
                                      v-model="getSubject"
                        ></v-text-field>
                    </v-flex>
                    <v-flex xs12 mb-5 mt-5>
                        <htmlEditor v-model="myHTML"></htmlEditor>
                    </v-flex>
                    <v-flex xs12 mb-1>
                        <v-layout row>
                            <DocumentTokenChip
                                    v-show="getOrderConfirmationDocumentId!== 0"
                                    :documentsId="getOrderConfirmationDocumentId"
                                    :documentFilename="getAttachmentFilenameOC"
                            >
                            </DocumentTokenChip>

                            <DocumentTokenChip
                              v-show="getProformaDocumentId!== 0 && selectedItem.proforma"
                              :documentsId="getProformaDocumentId"
                              :documentFilename="getAttachmentFilenamePRO"
                            >
                            </DocumentTokenChip>
                        </v-layout>
                        <v-layout>
                            <v-btn :disabled="selectedSendToItems.length <= 0"  block mt-5 color="secondary" @click="sendSupplierRequest()">
                                Send Order Confirmation
                                <v-icon class="white--text" right>send</v-icon>
                            </v-btn>
                        </v-layout>
                    </v-flex>
                    <v-flex xs12 mb-5>
                        <v-layout justify-end>
                            <v-btn block dark color="secondary" @click="createProcurement()">
                                Create Procurement
                                <v-icon class="icon-padding" v-html="'fa fa-shopping-cart'"></v-icon>
                            </v-btn>
                        </v-layout>
                    </v-flex>
                </v-container>
            </v-layout>

        </div>

    </div>

</template>


<script>
    import {
        Settings,
        CustomerBranchOfficeContact,
        InquirySupplierRequests,
        PurchaseOrder

    } from '../../../store/namespace-helper'

    import DocumentTokenChip from '../../Shared/DocumentTokenChip.vue'
    import htmlEditor from '../../Shared/editor/Editr.vue'

    export default {
      components: {
        DocumentTokenChip,
        htmlEditor
      },
      name: 'sendOrderConfirmation',
      data () {
        return {
          isVisible: false,
          onDismissed: false,
          showAttachment: true,
          sheet: false,
          chipsDeletable: true,
          myHTML: '',
          selectedSendToItems: [],
          selectedCCItems: [],
          selectedBCCItems: [],
          customContactFilter (item, queryText, itemText) {
            const isMatch = (test, query) => {
              return test.toString().toLowerCase().indexOf(query.toString().toLowerCase()) > -1
            }
            const query = queryText || ''
            const displayText = item.title + ' ' + item.firstname + ' ' + item.lastname
            const rc = isMatch(item.firstname, query) ||
                        isMatch(item.lastname, query) ||
                        isMatch(item.email, query) ||
                        isMatch(displayText, query)
            console.log(`filter: ${JSON.stringify(item)}, '${query}', ${JSON.stringify(itemText)} => ${rc}`)
            return rc
          }
        }
      },
      mounted () {
        console.log('dialog visible, load data')
      },
      methods: {
        visibilityChanged (isVisible, entry) {
          if (this.isVisible !== isVisible) {
            this.isVisible = isVisible
            if (isVisible) {
              this.$store.dispatch(InquirySupplierRequests.actions.loadInquirySupplierRequestsMessage, this.selectedItem.messages_id)
                        /* this.$store.dispatch(ContactPersonSettings.actions.loadContactPersonsBySupplierId, this.selectedItem.suppliers_id) */
            } else {
              this.activeTab = 0

              this.selectedSendToItems = []
              this.selectedCCItems = []
              this.selectedBCCItems = []
              this.myHTML = ''
              this.$store.getters[InquirySupplierRequests.getters.getInquirySupplierRequestsMessage].messages_content = ''
            }
          }
        },
        closeDialog () {
          this.selectedSendToItems = []
          this.selectedCCItems = []
          this.selectedBCCItems = []
          this.$store.dispatch(InquirySupplierRequests.actions.setInquirySupplierRequestsMessage, null)
          this.$store.dispatch(InquirySupplierRequests.actions.openCloseInquirySupplierRequestMessageDialog)
        },
        removeSendToItem (item) {
          const index = this.selectedSendToItems.indexOf(item.id)
          if (index >= 0) this.selectedSendToItems.splice(index, 1)
        },
        removeCCItem (item) {
          const index = this.selectedCCItems.indexOf(item.id)
          if (index >= 0) this.selectedCCItems.splice(index, 1)
        },
        removeBCCItem (item) {
          const index = this.selectedBCCItems.indexOf(item.id)
          if (index >= 0) this.selectedBCCItems.splice(index, 1)
        },
        sendSupplierRequest () {
          this.$store.getters[InquirySupplierRequests.getters.getInquirySupplierRequestsMessage].messages_content = this.myHTML
          let data = {
            id: this.selectedItem.id,
            message: this.$store.getters[InquirySupplierRequests.getters.getInquirySupplierRequestsMessage],
            to: this.selectedSendToItems,
            cc: this.selectedCCItems,
            bcc: this.selectedBCCItems,
            subject: this.getSubject
          }
          this.$store.dispatch(PurchaseOrder.actions.sendOrderConfirmation, data).then(response => {
            // this.closeDialog()
          })
        },
        createProcurement () {
          return this.$store.dispatch(PurchaseOrder.actions.createProcurement, this.selectedItem)
        },
        onDismissedError () {
          this.$store.dispatch(Settings.actions.clearNetworkError)
          setTimeout(function () {
            location.reload()
          }, 850)
        },
        openBottomSheet (payload) {
          if (payload) {
            this.$store.dispatch('openCloseBottomSheet')
          }
        }
      },
      computed: {
        selectedItem () {
          return this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder]
        },
        getMessage () {
          return this.$store.getters[InquirySupplierRequests.getters.getInquirySupplierRequestsMessage].messages_content
        },
        getCustomerBranchOfficeContacts () {
          return this.$store.getters[CustomerBranchOfficeContact.getters.getContactPersons]
        },
        getSubject () {
          return 'Order Confirmation - ' + this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder].purchase_orders_number
        },
        getAttachmentFilenameOC () {
          return this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder].purchase_orders_number + '.pdf'
        },
        getAttachmentFilenamePRO () {
          return this.$store.getters[PurchaseOrder.getters.getSelectedPurchaseOrder].purchase_orders_proforma_number + '.pdf'
        },
        getOrderConfirmationDocumentId () {
          if (this.selectedItem.message && this.selectedItem.message.attachments) {
            if (this.selectedItem.message.attachments[0]) {
              return this.selectedItem.message.attachments[0].documents_id
            }
          }
          return 0
        },
        getProformaDocumentId () {
          if (this.selectedItem.message && this.selectedItem.message.attachments) {
            if (this.selectedItem.message.attachments[1]) {
              return this.selectedItem.message.attachments[1].documents_id
            }
          }
          return 0
        },
        getWindowWidth () {
          return window.innerWidth
        },
        getWindowHeight () {
          return window.innerHeight
        },
        getNetworkError () {
          return this.$store.getters[Settings.getters.getNetworkError]
        },
        loading () {
          return this.$store.getters[Settings.getters.loading] && this.isVisible
        }
      },
      watch: {
        getMessage: {
          handler (val) {
            this.myHTML = val
          },
          deep: true

        },
        getSupplierContactsForRequests: {
          handler (val) {
            let tempContacts = this.selectedSendToItems
            if (val !== null && this.isVisible) {
              val.forEach(function (element) {
                if (element.main_contact === 1) {
                  tempContacts.push(element.id)
                }
              })

              this.selectedSendToItems = tempContacts
            }
          },
          deep: true

        }
      }

    }
</script>


<style scoped>

    .line-height {
        height: 35px;
    }

    .loading-dialog {
        overflow: hidden;
        -ms-overflow-style: none;
    }

    .loading-dialog::-webkit-scrollbar {
        display: none;
    }

    .icon-padding {
        padding-left: 12px;
    }

    #menu-button {
        margin-top: 4px;
        width: 55px;
        height: 55px;
    }

</style>



// WEBPACK FOOTER //
// src/components/PurchaseOrders/SendOrderConfirmation/SendOrderConfirmationMessage.vue